import { api } from "./api";

const MAX_DIM = 1280;
const QUALITY = 0.72;

async function bitmapOtimizado(file) {
  // Sem hints de resize aqui: eles forçam a proporção quadrada. O corte de
  // resolução acontece no canvas, preservando o aspect ratio original.
  if ("createImageBitmap" in window) {
    return await createImageBitmap(file);
  }
  const url = URL.createObjectURL(file);
  try {
    return await new Promise((res, rej) => {
      const img = new Image();
      img.onload = () => res(img);
      img.onerror = rej;
      img.src = url;
    });
  } finally {
    URL.revokeObjectURL(url);
  }
}

// Reduz a foto para no máximo 1280px em JPEG ~72% antes de qualquer uso.
// O original nunca é mantido em memória após o processamento.
export async function processarFoto(file) {
  if (!file || !(file.type || "").startsWith("image/")) return file;
  const bmp = await bitmapOtimizado(file);
  try {
    const scale = Math.min(1, MAX_DIM / Math.max(bmp.width, bmp.height));
    const w = Math.max(1, Math.round(bmp.width * scale));
    const h = Math.max(1, Math.round(bmp.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bmp, 0, 0, w, h);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
    canvas.width = 0;
    canvas.height = 0;
    if (!blob) return file;
    const nome = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], nome, { type: "image/jpeg" });
  } finally {
    bmp.close?.();
  }
}

export async function logErroUpload(contexto, err, file) {
  try {
    if (process.env.NODE_ENV !== "production") console.warn("[upload erro]", contexto, err);
    await api.post("/logs/erro-upload", {
      contexto,
      erro: String(err?.response?.data?.detail || err?.message || err).slice(0, 300),
      arquivo: (file?.name || "").slice(0, 120),
      tamanho: file?.size || 0,
      ua: (navigator.userAgent || "").slice(0, 200),
    });
  } catch {}
}

// Envia a foto já otimizada; em falha, registra o erro técnico e lança mensagem amigável.
export async function uploadFoto(file, contexto) {
  const otimizada = await processarFoto(file);
  const fd = new FormData();
  fd.append("files", otimizada);
  try {
    const r = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data.files[0].path;
  } catch (e) {
    await logErroUpload(contexto, e, file);
    const msg = e.response?.data?.detail;
    throw new Error(typeof msg === "string" ? msg : "Não foi possível enviar a foto. Tente novamente.");
  }
}
